import {createSlice} from "@reduxjs/toolkit";
import {login} from "./auth.action";

interface IInitState {
    isAuth: boolean;
    error: unknown;
    isLoading: boolean
}

const initialState: IInitState = {
    isLoading: false,
    error: null,
    isAuth: false
}

const authReducer = createSlice({
    name: 'auth',
    reducers: {
        setLogout: (state) => {
            state.isAuth = false
            localStorage.setItem('access_token', '')
        },
    },
    initialState,
    extraReducers: builder => {
        builder
            .addCase(login.pending, ((state) => {
                state.isLoading = true
            }))
            .addCase(login.fulfilled, ((state, {payload}) => {
                state.isLoading = false
                state.isAuth = true
            }))
            .addCase(login.rejected, ((state, {error}) => {
                state.isLoading = false
                state.error = error
            }))
        // .addCase(logout, () => {
        //     return initialState
        // })

    }
})

export const {setLogout} = authReducer.actions

export default authReducer.reducer
